import axios from "../../utils/axios";

export const getPost = async (id) => {
    const response = await axios.get(`/blogs/${id}`);
    return response.data;
};

export const updateSaveBtn = async(postId, isSaved)=>{ 
    const response = await axios.patch(`/blogs/${postId}`, {isSaved: !isSaved});
    return response.data;
}
export const updateLikeBtn = async(postId, likes)=>{ 
    const response = await axios.patch(`/blogs/${postId}`, {likes: likes + 1 });
    return response.data;
}